import { render } from "./MatchingDropdown.vue?vue&type=template&id=9a99dcf4&scoped=true"
import script from "./MatchingDropdown.vue?vue&type=script&lang=js"
export * from "./MatchingDropdown.vue?vue&type=script&lang=js"

import "./MatchingDropdown.vue?vue&type=style&index=0&id=9a99dcf4&lang=scss&scoped=true"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a99dcf4"]])

export default __exports__